import { RLChecksReport } from "@sscs/types";
export const getCheck = (checks, checkType) => {
    return checks === null || checks === void 0 ? void 0 : checks.find((check) => check.type === checkType);
};
export const convertScanCheckLabel = (label) => {
    if (!label) {
        return {
            status: undefined,
            scanLevel: undefined,
            isRepro: false,
            isDiff: false,
        };
    }
    const [reportType, statusLabel] = label.split(":");
    if (!RLChecksReport.stringIsScanCheckLabel(label)) {
        throw new Error("Invalid scan check label");
    }
    const status = statusLabel.toLowerCase() === "fail" ? "fail" : "pass";
    const isRepro = reportType === "RB";
    const isDiff = reportType === "DF";
    const scanLevel = Number.isNaN(parseInt(reportType[1]))
        ? undefined
        : parseInt(reportType[1]);
    return {
        status,
        scanLevel,
        isRepro,
        isDiff,
    };
};
export const convertFinalCheckLabel = (checks) => {
    var _a;
    const scanCheckLabel = (_a = checks === null || checks === void 0 ? void 0 : checks.find((check) => check.final)) === null || _a === void 0 ? void 0 : _a.label;
    return convertScanCheckLabel(scanCheckLabel);
};
const CHECKS_DESCRIPTIONS = {
    "VERSION-REPORT": "Software package analysis",
    "VERSION-DIFF": "Diff with:",
    "REPRO-REPORT": "Software package analysis: repro",
    "REPRO-DIFF": "Diff with: repro",
    "REPRO-CHECK": "Reproducible build check",
};
export const transformPerformedChecks = ({ scans, selectedScan, shouldLinkToAnotherReport, requestedDiff, diffId, }) => {
    var _a, _b, _c, _d;
    const checks = [];
    const hasVersionLinks = selectedScan === "scan-version" ? true : shouldLinkToAnotherReport;
    const hasReproLinks = selectedScan === "scan-repro" ? true : shouldLinkToAnotherReport;
    const versionLinkType = selectedScan === "scan-version" ? "CURRENT_REPORT" : "NEW_REPORT";
    const reproLinkType = selectedScan === "scan-repro" ? "CURRENT_REPORT" : "NEW_REPORT";
    // Order is extremely important and needs to be preserved
    // Follows report order of https://alt-confluence.rl.lan/display/SwA/CLI+application list command
    checks.push({
        label: (_a = getCheck(scans["scan-version"].checks, "artifact-check")) === null || _a === void 0 ? void 0 : _a.label,
        description: CHECKS_DESCRIPTIONS["VERSION-REPORT"],
        checkType: "VERSION-REPORT",
        link: hasVersionLinks
            ? {
                type: versionLinkType,
                label: "Issues",
            }
            : undefined,
    });
    // There can be N diff checks in RL-SAFE
    // Portal always has one
    // Standalone and RL-SAFE report can have many
    //
    // When there are multiple diffs, standalone report should only link to the
    // currently loaded one (requestedDiff). RL-SAFE has links to all diffs, it
    // either navigates to issues diff in the current report (when reference
    // matches diffId) or reloads the report with the check reference diff before
    // navigating to issues diff
    //
    // NB: In standalone report, diffId is set to "standalone-report-diff-id",
    // and in RL-SAFE requestedDiff isn't provided
    scans["scan-version"].checks.forEach((check) => {
        if (check.type === "artifact-diff") {
            let hasLink = hasVersionLinks;
            // Don't link to other diffs in standalone report
            if (requestedDiff && check.reference !== requestedDiff) {
                hasLink = false;
            }
            checks.push({
                label: check.label,
                description: `${CHECKS_DESCRIPTIONS["VERSION-DIFF"]} ${check.reference}`,
                checkType: "VERSION-DIFF",
                link: hasLink
                    ? {
                        type: check.reference === diffId || requestedDiff
                            ? versionLinkType
                            : "NEW_REPORT",
                        label: "Diff",
                        reference: check.reference,
                    }
                    : undefined,
            });
        }
    });
    if (scans["scan-repro"]) {
        checks.push({
            label: (_b = getCheck(scans["scan-repro"].checks, "artifact-check")) === null || _b === void 0 ? void 0 : _b.label,
            description: CHECKS_DESCRIPTIONS["REPRO-REPORT"],
            checkType: "REPRO-REPORT",
            link: hasReproLinks
                ? {
                    type: reproLinkType,
                    label: "Repro report",
                }
                : undefined,
        });
        checks.push({
            label: (_c = getCheck(scans["scan-repro"].checks, "artifact-diff")) === null || _c === void 0 ? void 0 : _c.label,
            description: CHECKS_DESCRIPTIONS["REPRO-DIFF"],
            checkType: "REPRO-DIFF",
            link: hasReproLinks
                ? {
                    type: reproLinkType,
                    label: "Repro check",
                }
                : undefined,
        });
        checks.push({
            label: (_d = getCheck(scans["scan-repro"].checks, "repro-check")) === null || _d === void 0 ? void 0 : _d.label,
            description: CHECKS_DESCRIPTIONS["REPRO-CHECK"],
            checkType: "REPRO-CHECK",
            link: hasReproLinks
                ? {
                    type: reproLinkType,
                    label: "Repro check",
                }
                : undefined,
        });
    }
    return checks;
};
//# sourceMappingURL=checks.js.map